export default class SectionNotFoundException extends Error {
  static exceptionName = 'SectionNotFoundException'

  constructor(message) {
    super(message)
    this.name = SectionNotFoundException.exceptionName
  }
}
